

var miniSectionV2Fn = function (section) {
    section = $(section);
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.title'), {
                y: '10vw',
                opacity: 0
            }, 0)
            .from(section.find('.links'), {
                y: '10vw',
                opacity: 0,
                delay:.5,
            }, 0)
            .from(section.find('.pro'), {
                y: '10vw',
                opacity: 0,
                delay:.5,
            }, 0)
            .from(section.find('.desc'), {
                y: '10vw',
                opacity: 0,
                delay:.5,
            }, 0)
    });
};
var miniSectionV2Init = function () {
    var cardGroupV2 = $('.mini-section-v2');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV2Fn(cardGroupV2[i]);
    }
};
miniSectionV2Init();


var miniSectionV3Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    let isMobile = window.matchMedia("(any-pointer:coarse)").matches;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.section-top'), 
                {
                    y: '0',
                    duration:110,
                    delay:15
                },
            0)
            .to(section.find('.section-content'), 
                {
                    y: isMobile?'-168.25vw':'-15.25vw',
                    duration:isMobile?150:150,
                    delay:isMobile?40:20
                },
            0)

            /*.from(section.find('.flex-left-1'), {
                y: '2vw',
                opacity: 0,
                duration:40,
                delay:20
            }, 0)
            .from(section.find('.flex-left-4'), {
                y: '2vw',
                opacity: 0,
                duration:40,
                delay:21
            }, 0)
            .from(section.find('.flex-left-2'), {
                y: '2vw',
                opacity: 0,
                duration:40,
                delay:22
            }, 0)
            .from(section.find('.flex-left-3'), {
                y: '2vw',
                opacity: 0,
                duration:40,
                delay:23
            }, 0)
            
            .from(section.find('.flex-left-5'), {
                y: '2vw',
                opacity: 0,
                duration:40,
                delay:24
            }, 0)
            .from(section.find('.flex-left-6'), {
                y: '2vw',
                opacity: 0,
                duration:40,
                delay:25
            }, 0)*/
    });
};
var miniSectionV3Init = function () {
    var cardGroupV2 = $('.mini-section-v3');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV3Fn(cardGroupV2[i]);
    }
};
miniSectionV3Init();


var miniSectionV4Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.imgs'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            
    });
};
var miniSectionV4Init = function () {
    var cardGroupV2 = $('.mini-section-v4');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV4Fn(cardGroupV2[i]);
    }
};
miniSectionV4Init();



var miniSectionV5Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.imgs'), {
                y: '10vw',
                opacity: 0,
            }, 0)
    });
};
var miniSectionV5Init = function () {
    var cardGroupV2 = $('.mini-section-v5 .section-top');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV5Fn(cardGroupV2[i]);
    }
};
miniSectionV5Init();



var miniSectionV18Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            /*.from(section.find('.imgs'), {
                opacity: 0,
            }, 0)*/
            .from(section.find('.title-img'), {
                y: '2vw',
                opacity: 0
            }, 0)
            .from(section.find('.ele-box'), {
                y: '2vw',
                opacity: 0
            }, 0)
            .from(section.find('.title'), {
                y: '2vw',
                opacity: 0
            }, 0)
            .from(section.find('.desc'), {
                y: '2vw',
                opacity: 0
            }, 0)


            /*.from(section.find('.speed-mode'), {
                opacity: '0',
                delay:2,
            }, 0)*/
            .from(section.find('.speed-title'), {
                y: '2vw',
                opacity: 0,
            }, 0)
            


            .from(section.find('.item')[0], {
                y: '1vw',
                opacity: 0,
                delay:.3
            }, 0)
            .from(section.find('.item')[1], {
                y: '1vw',
                opacity: 0,
                delay:.6
            }, 0)
            .from(section.find('.item')[2], {
                y: '1vw',
                opacity: 0,
                delay:.9
            }, 0)
            .from(section.find('.item')[3], {
                y: '1vw',
                opacity: 0,
                delay:1.2
            }, 0)

            .from(section.find('.speed-desc'), {
                y: '5vw',
                opacity: 0,
                delay:1.5
            }, 0)

    });
};
var miniSectionV18Init = function () {
    var cardGroupV2 = $('.mini-section-v18');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV18Fn(cardGroupV2[i]);
    }
};
miniSectionV18Init();





var miniSectionV6Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            /*.from(section.find('.sub-title,.title'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            .from(section.find('.imgs'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            .from(section.find('.desc'), {
                y: '10vw',
                opacity: 0,
            }, 0)*/
            .from(section.find('.swiper-flex'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            
            
    });
};
var miniSectionV6Init = function () {
    var cardGroupV2 = $('.mini-section-v6');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV6Fn(cardGroupV2[i]);
    }
};
miniSectionV6Init();


var miniSectionV7Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.con-left'), {
                y: '2vw',
                opacity: 0,
            }, 0)
            .from(section.find('.con-right'), {
                y: '2vw',
                opacity: 0
            }, 0)
            
    });
};
var miniSectionV7Init = function () {
    var cardGroupV2 = $('.mini-section-v7');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV7Fn(cardGroupV2[i]);
    }
};
miniSectionV7Init();



var miniSectionVideoFn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.sub-title,.title'), {
                y: '2vw',
                opacity: 0,
            }, 0)
            .from(section.find('.desc1,.desc2'), {
                y: '2vw',
                opacity: 0,
                delay:2
            }, 0)

            .from(section.find('.icon-play'), {
                opacity: 0,
                delay:2
            }, 0)
            
    });
};
var miniSectionVideoInit = function () {
    var cardGroupV2 = $('.mini-section-video');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionVideoFn(cardGroupV2[i]);
    }
};
miniSectionVideoInit();



var miniSectionV8Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
           .from(section.find('.imgs'), {
                opacity: 0,
            }, 0)
            .from(section.find('.title-img,.s-ele,.numbers,.sub-title'), {
                y: '2vw',
                opacity: 0,
            }, 0)
            .from(section.find('.tab-cont'), {
                y: '2vw',
                opacity: 0,
                delay:1
            }, 0)
            
    });
};
var miniSectionV8Init = function () {
    var cardGroupV2 = $('.mini-section-v8');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV8Fn(cardGroupV2[i]);
    }
};
miniSectionV8Init();




var miniSectionV9Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.section-warp'), {
                y: '5vw',
                opacity: 0,
            }, 0)
            
            
            
    });
};
var miniSectionV9Init = function () {
    var cardGroupV2 = $('.mini-section-v9');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV9Fn(cardGroupV2[i]);
    }
};
miniSectionV9Init();




var miniSectionV10Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.imgs'), {
                opacity: 0,
            }, 0)

            .from(section.find('.section-warp'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            
    });
};
var miniSectionV10Init = function () {
    var cardGroupV2 = $('.mini-section-v10');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV10Fn(cardGroupV2[i]);
    }
};
miniSectionV10Init();


var miniSectionV11Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.section-warp'), {
                y: '5vw',
                opacity: 0,
            }, 0)
            
    });
};
var miniSectionV11Init = function () {
    var cardGroupV2 = $('.mini-section-v11');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV11Fn(cardGroupV2[i]);
    }
};
miniSectionV11Init();



var miniSectionV12Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.item-box1'), {
                y: '2vw',
                opacity: 0,
                delay:1
            }, 0)
            .from(section.find('.item-box2'), {
                y: '2vw',
                opacity: 0,
                delay:2
            }, 0)
            .from(section.find('.item-box3'), {
                y: '2vw',
                opacity: 0,
                delay:2
            }, 0)
            .from(section.find('.item-box4'), {
                y: '2vw',
                opacity: 0,
                delay:5
            }, 0)


            .from(section.find('.imgs'), {
                opacity: 0,
                delay:3
            }, 0)
            .from(section.find('.btn'), {
                y: '2vw',
                opacity: 0,
                delay:3
            }, 0)
            .from(section.find('.tab-list'), {
                y: '2vw',
                opacity: 0,
                delay:3
            }, 0)
            
    });
};
var miniSectionV12Init = function () {
    var cardGroupV2 = $('.mini-section-v12');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV12Fn(cardGroupV2[i]);
    }
};
miniSectionV12Init();

var miniSectionV13Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.section-warp'), {
                y: '10vw',
                opacity: 0,
            }, 0)

            .from(section.find('.btn,.title'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            .from(section.find('.subtitle,.desc'), {
                y: '10vw',
                opacity: 0,
            }, 0)
            
    });
};
var miniSectionV13Init = function () {
    var cardGroupV2 = $('.mini-section-v13');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV13Fn(cardGroupV2[i]);
    }
};
miniSectionV13Init();


var miniSectionV14Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.btn,.title,.subtitle'), {
                y: '5vw',
                opacity: 0
            }, 0)

            .from(section.find('.z1-section-card-group-v4-card')[0], {
                y: '5vw',
                opacity: 0,
                duration:2,
                delay:.5
            }, 0)
            .from(section.find('.z1-section-card-group-v4-card')[1], {
                y: '5vw',
                opacity: 0,
                duration:2,
                delay:1
            }, 0)
            .from(section.find('.z1-section-card-group-v4-card')[2], {
                y: '5vw',
                opacity: 0,
                duration:2,
                delay:1.5
            }, 0)
            .from(section.find('.z1-section-card-group-v4-card')[3], {
                y: '5vw',
                opacity: 0,
                duration:2,
                delay:2
            }, 0)
            .from(section.find('.z1-section-card-group-v4-card')[4], {
                y: '5vw',
                opacity: 0,
                duration:2,
                delay:2.5
            }, 0)
            .from(section.find('.z1-section-card-group-v4-card')[5], {
                y: '5vw',
                opacity: 0,
                duration:2,
                delay:3
            }, 0)


            
    });
};
var miniSectionV14Init = function () {
    var cardGroupV2 = $('.mini-section-v14');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV14Fn(cardGroupV2[i]);
    }
};
miniSectionV14Init();



var miniSectionV17Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.fixed-box'), {
                //y: '10vw',
                opacity: 0,
            }, 0)
    });
};
var miniSectionV17Init = function () {
    var cardGroupV2 = $('.mini-section-v17');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV17Fn(cardGroupV2[i]);
    }
};
miniSectionV17Init();




var miniSectionV15Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top top',
        end: '+=' + (clientHeight),
        scrub: true,
        pin: true,
        animation: gsap.timeline()
            .to(section.find('.slogin-box'), {
                opacity: 0,
                duration:100,
                delay:5
            }, 0)
            .to(section.find('.pro-img'), {
                left: '26%',
                opacity: 1,
                duration:100,
                delay:8
            }, 0)
            .to(section.find('.item-list'), {
                left: '63%',
                opacity: 1,
                duration:100,
                delay:8
            }, 0)
            .to(section.find('.item-list'), {
                delay:480
            }, 0)
            
    });
};
var miniSectionV15Init = function () {
    var cardGroupV2 = $('.mini-section-v15');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV15Fn(cardGroupV2[i]);
    }
};
miniSectionV15Init();



var miniSectionV16Fn = function (section) {
    section = $(section);
    var clientHeight = document.documentElement.clientHeight;
    var clientWidth = document.documentElement.clientWidth;
    var headerHeight = document.querySelector('header').clientHeight + document.querySelector('aside').clientHeight;
    var trigger = section[0];
    ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        end: 'top top',
        scrub: true,
        animation: gsap.timeline()
            .from(section.find('.btn'), {
                y: '5vw',
                opacity: 0,
            }, 0)

            .from(section.find('.flex-li')[0], {
                y: '5vw',
                opacity: 0,
                duration:1,
                delay:.5
            }, 0)
            .from(section.find('.flex-li')[1], {
                y: '5vw',
                opacity: 0,
                duration:1,
                delay:1
                
            }, 0)
            .from(section.find('.flex-li')[2], {
                y: '5vw',
                opacity: 0,
                duration:1,
                delay:1.5
            }, 0)
            
    });
};
var miniSectionV16Init = function () {
    var cardGroupV2 = $('.mini-section-v16');
    for (var i = 0; i < cardGroupV2.length; i++) {
        miniSectionV16Fn(cardGroupV2[i]);
    }
};
miniSectionV16Init();












/*
$(".mini-section-v4 .item").mouseenter(
    function(){
        $(".mini-section-v4 .item").stop().removeClass("cut").css({width:'27.23958vw'});
        $(this).stop().addClass("cut").animate({width:"40.625vw"},200);
    }
)

$(".mini-section-v4 .item").eq(0).addClass("cut").css({width:'40.625vw'});
*/



$(".mini-section-v8 .item").click(function(){
    let index= $(this).index();
    $(".mini-section-v8 .tab-conts").hide().eq(index).show();
    $(".mini-section-v8 .item").removeClass("cut").eq(index).addClass("cut");
})
$(".mini-section-v8 .item").eq(0).click();


$(".mini-section-v9 .item").mouseenter(
    function(){
        $(".mini-section-v9 .item").stop().removeClass("cut").css({width:'27.23958vw'});
        $(this).stop().addClass("cut").animate({width:"40.625vw"},200);
    }
)

$(function(){
    $(".mini-section-v9 .item").eq(0).addClass("cut").css({width:'40.625vw'});
})